/**
 * 项目分成比例：一级/二级结构转换
 * 后端比例：100% = 10000，0.01% = 1
 */

export function createEmptyRateItem({
	serNo = 0,
	rate = 0,
	company = null,
	payCompany = 0,
	rangeDetail = [],
	testRunRate = null,
} = {}) {
	return {
		targetCompanyId: company ? company.id : null,
		showCompanyId: '',
		rate,
		testRunRate,
		serNo,
		incomePlanId: '1',
		rangeDetail: rangeDetail || [],
		payCompany,
		targetCompanyInfo: company
			? {
				label: company.name,
				value: company.id,
				payPlatform: company.payPlatform,
			}
			: '',
		childList: [],
	}
}

function mapOneFromApi(item) {
	const targetCompanyId = item.targetCompanyId || item.companyId
	const targetCompanyName = item.targetCompanyName || item.companyName || item.name || ''
	return {
		targetCompanyId,
		showCompanyId: item.showCompanyId != 2 ? '' : item.showCompanyId,
		payCompany: item.payCompany ? item.payCompany : 0,
		rate: (item.rate || 0) / 100,
		testRunRate: item.testRunRate != null ? item.testRunRate / 100 : null,
		serNo: item.serNo,
		incomePlanId: item.incomePlanId,
		rangeDetail: [],
		targetCompanyInfo: item.targetCompanyInfo && item.targetCompanyInfo.value
			? item.targetCompanyInfo
			: {
				label: targetCompanyName,
				value: targetCompanyId,
				payPlatform: item.payPlatform,
			},
		childList: [],
	}
}

export function mapFixedItemFromApi(item) {
	const mapped = mapOneFromApi(item)
	mapped.childList = (item.childList || []).map((child) => {
		const childMapped = mapOneFromApi(child)
		childMapped.childList = []
		return childMapped
	})
	return mapped
}

function mapOneToSubmit(item) {
	const targetCompanyId = (item.targetCompanyInfo && item.targetCompanyInfo.value)
		|| item.targetCompanyId
	return {
		...item,
		showCompanyId: item.showCompanyId ? item.showCompanyId : targetCompanyId,
		targetCompanyId,
		rate: Number(item.rate || 0) * 100,
		testRunRate: Number((item.testRunRate != null ? item.testRunRate : item.rate) || 0) * 100,
		serNo: item.serNo,
		rangeDetail: (item.rangeDetail || []).map((rangeItem) => ({
			rate: Number(rangeItem.rate || 0) * 100,
			minAmount: Number(rangeItem.minAmount || 0) * 100,
			maxAmount: Number(rangeItem.maxAmount || 0) * 100,
		})),
	}
}

export function mapDetailListToSubmit(detail) {
	return (detail || []).map((item) => {
		const mapped = mapOneToSubmit(item)
		mapped.childList = (item.childList || []).map((child) => {
			const childMapped = mapOneToSubmit(child)
			childMapped.childList = []
			return childMapped
		})
		return mapped
	})
}

export function isRateEqual(a, b) {
	return Math.round(Number(a || 0) * 100) === Math.round(Number(b || 0) * 100)
}

export function isTargetSplitModeTwo(targetInfo) {
	return !!(targetInfo && targetInfo.splitMode == 2)
}

export function isTargetSplitModeTwoActive(targetInfo) {
	return !!(targetInfo && targetInfo.splitMode == 2 && targetInfo.status != null && targetInfo.status != 0)
}

export function getInvestorCompanyIdFromTarget(targetInfo) {
	if (!isTargetSplitModeTwo(targetInfo)) return null
	return targetInfo.companyId || null
}

export function getMaxSerNo(detail) {
	let maxSerNo = 0
	;(detail || []).forEach((item) => {
		if (item.serNo >= maxSerNo) {
			maxSerNo = item.serNo
		}
		;(item.childList || []).forEach((child) => {
			if (child.serNo >= maxSerNo) {
				maxSerNo = child.serNo
			}
		})
	})
	return maxSerNo
}
